import { EventEmitter, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DEFAULT_SECURITY_GROUP_TAB_OPTIONS, SET_OPERATION_RADIO_BUTTONS, SET_OPERATION_TO_RADIO_BUTTON_MAP, } from '../constants';
import { COMPANY } from 'NewAngular/constants/core.constants';
import { INTERSECT } from 'SecurityListsApp/ts/constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { isMultiSelectListItemSelected } from 'SecurityListsApp/ts/features/security-list-selector-modals/components/multi-select-list/utils/multi-select-list-utils';
import * as i0 from "@angular/core";
import * as i1 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
import * as i11 from "../components/autocompleter-multi-select-list/autocompleter-multi-select-list.component";
import * as i12 from "../components/category-list/category-list.component";
import * as i13 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-level-multi-select-list/multi-level-multi-select-list.component";
import * as i14 from "../components/security-list-group-tabs/security-list-group-tabs.component";
const _c0 = ["multiSelectList"];
const _c1 = a0 => ({ "tab-pane active": a0 });
const _c2 = a0 => ({ "linked-lists-no-border": a0 });
function MultiSecurityListSelectorModalComponent_ycn_radio_button_group_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-radio-button-group", 9);
    i0.ɵɵlistener("selectHandler", function MultiSecurityListSelectorModalComponent_ycn_radio_button_group_4_Template_ycn_radio_button_group_selectHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectSetOperation($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("groupName", "multiSecurityListSelectorModalSetOperations")("options", ctx_r1.setOperations)("selectedObject", ctx_r1.selectedSetOperationObj);
} }
function MultiSecurityListSelectorModalComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 7);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_security_list_group_tabs_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-security-list-group-tabs", 22);
    i0.ɵɵlistener("securityGroupChangeHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_security_list_group_tabs_0_Template_ycn_security_list_group_tabs_securityGroupChangeHandler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectSecurityGroup($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("activeSecurityGroupTab", ctx_r1.activeSecurityGroupTab)("securityGroupTabOptions", ctx_r1.securityGroupTabOptions);
} }
function MultiSecurityListSelectorModalComponent_Conditional_7_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "ycn-icon-search-autocomplete", 24);
    i0.ɵɵlistener("submitHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_div_11_Template_ycn_icon_search_autocomplete_submitHandler_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectSubListItemByAutocomplete($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("appendToBody", false)("placeholder", ctx_r1.autocompleterPlaceholder)("searchType", ctx_r1.autocompleterName);
} }
function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_autocompleter_multi_select_list_12_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-autocompleter-multi-select-list", 25);
    i0.ɵɵlistener("removeItemHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_autocompleter_multi_select_list_12_Template_ycn_autocompleter_multi_select_list_removeItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeItem($event)); })("selectItemHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_autocompleter_multi_select_list_12_Template_ycn_autocompleter_multi_select_list_selectItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectAutocompleteResult($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("autocompleterName", ctx_r1.autocompleterName)("autocompleterPlaceholder", ctx_r1.autocompleterPlaceholder)("selectedItems", ctx_r1.selectedItems);
} }
function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_multi_level_multi_select_list_15_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-multi-level-multi-select-list", 26, 0);
    i0.ɵɵlistener("selectItemHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_ycn_multi_level_multi_select_list_15_Template_ycn_multi_level_multi_select_list_selectItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectListItem($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("listItems", ctx_r1.listItems)("activeSecurityGroupTab", ctx_r1.activeSecurityGroupTab)("selectedItems", ctx_r1.selectedItems);
} }
function MultiSecurityListSelectorModalComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, MultiSecurityListSelectorModalComponent_Conditional_7_ycn_security_list_group_tabs_0_Template, 1, 2, "ycn-security-list-group-tabs", 10);
    i0.ɵɵelementStart(1, "div", 11)(2, "div", 12)(3, "div", 13)(4, "div", 14)(5, "div", 15);
    i0.ɵɵtext(6, "Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "ycn-category-list", 16);
    i0.ɵɵlistener("categoryChangeHandler", function MultiSecurityListSelectorModalComponent_Conditional_7_Template_ycn_category_list_categoryChangeHandler_7_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectCategory($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 14)(9, "div", 15);
    i0.ɵɵtext(10, "Lists");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, MultiSecurityListSelectorModalComponent_Conditional_7_div_11_Template, 2, 3, "div", 17)(12, MultiSecurityListSelectorModalComponent_Conditional_7_ycn_autocompleter_multi_select_list_12_Template, 1, 3, "ycn-autocompleter-multi-select-list", 18);
    i0.ɵɵelementStart(13, "div", 19)(14, "div", 20);
    i0.ɵɵtemplate(15, MultiSecurityListSelectorModalComponent_Conditional_7_ycn_multi_level_multi_select_list_15_Template, 2, 3, "ycn-multi-level-multi-select-list", 21);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.isTabbed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1, ctx_r1.isTabbed));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2, ctx_r1.isTabbed));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("categories", ctx_r1.categories)("categoryCounts", ctx_r1.activeTabCategoryCounts)("selectedCategory", ctx_r1.selectedCategory);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.listItems.length && ctx_r1.autocompleterName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.listItems.length && ctx_r1.autocompleterName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.listItems.length);
} }
/**
 * Multi Security List Selector Modal Component
 *
 * Displays a menu where you can select multiple security lists from a variety of groups and categories.
 *
 * Input Properties:
 *  activeSecurityGroupTab: The security group for which the security lists are currently being displayed.
 *  headerText: text to display in the modal header.
 *  securityGroupTabOptions: tabs to show in the modal.
 *  showSetOperations: Whether or not to show the set operation radio buttons.
 *  selectedSetOperation: the currently select set operation.
 *
 * Output Properties:
 *  submitHandler: Emits the selected security lists and set operation when the Submit button is clicked.
 */
export class MultiSecurityListSelectorModalComponent {
    constructor(securityListMenuService, featureService) {
        this.securityListMenuService = securityListMenuService;
        this.featureService = featureService;
        this.activeSecurityGroupTab = COMPANY;
        this.headerText = 'Select Security Lists';
        this.securityGroupTabOptions = DEFAULT_SECURITY_GROUP_TAB_OPTIONS;
        this.showSetOperations = true;
        this.selectedSetOperation = INTERSECT;
        this.submitHandler = new EventEmitter();
        this.autocompleterPlaceholder = '';
        // Set operations
        this.selectedSetOperationObj = SET_OPERATION_TO_RADIO_BUTTON_MAP[this.selectedSetOperation];
        this.setOperations = SET_OPERATION_RADIO_BUTTONS;
        // Menu data
        this.listItems = [];
        this.securityListMenu = null;
        // Categories
        this.categories = [];
        this.selectedCategory = '';
        this.activeTabCategoryCounts = {};
        this.groupCategoryCounts = {};
        // Boolean state
        this.isTabbed = this.securityGroupTabOptions.length > 1;
        this.loading = false;
        this.modalOpen = false;
        // Error Message to display
        this.errorText = '';
        this.selectedItems = [];
    }
    ngOnInit() {
        this.resetCategoryCounts();
        // Fetch security list menu
        this.loading = true;
        this.securityListMenuService
            .getMenu()
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: (response) => {
                this.securityListMenu = response;
                this.selectSecurityGroup(this.activeSecurityGroupTab);
            },
            error: () => {
                this.errorText = 'There was an unexpected error. Please reload the page.';
            },
        });
    }
    ngOnChanges(changes) {
        // If securityGroupTabOptions changes then update isTabbed based on how many tabs there are
        if (changes?.securityGroupTabOptions?.currentValue) {
            this.resetCategoryCounts();
            this.isTabbed = this.securityGroupTabOptions.length > 1;
        }
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.resetModal();
    }
    resetModal() {
        this.selectedItems = [];
        this.selectedSetOperation = INTERSECT;
        // Changing the object reference to trigger ngOnChanges in the RadioButtonGroupComponent
        this.selectedSetOperationObj = { ...SET_OPERATION_TO_RADIO_BUTTON_MAP[this.selectedSetOperation] };
        // Close all open lists
        if (this.multiSelectList) {
            this.multiSelectList.openListItems = [];
        }
        this.resetCategoryCounts();
    }
    submit() {
        if (this.selectedItems.length) {
            this.submitHandler.emit({ securityLists: this.selectedItems, setOperation: this.selectedSetOperation });
            this.closeModal();
        }
    }
    resetCategoryCounts() {
        const clearedCounts = {};
        this.securityGroupTabOptions.forEach((tabName) => {
            clearedCounts[tabName] = {};
        });
        this.groupCategoryCounts = clearedCounts;
        this.activeTabCategoryCounts = {};
    }
    selectCategory(newCategoryName) {
        this.selectedCategory = newCategoryName;
        const categorySubMenu = this.securityListMenu
            ? this.securityListMenu[this.activeSecurityGroupTab].find((categoryMenu) => categoryMenu.name === newCategoryName)
            : undefined;
        if (categorySubMenu) {
            this.listItems = categorySubMenu.list_items || [];
            this.autocompleterName = categorySubMenu.autocompleter_name;
            this.autocompleterPlaceholder = `Search for ${categorySubMenu.name}`;
        }
    }
    selectSetOperation(newSetOperation) {
        this.selectedSetOperation = newSetOperation;
    }
    selectSecurityGroup(newSecurityGroup) {
        this.activeSecurityGroupTab = newSecurityGroup;
        this.categories = this.securityListMenu ? this.securityListMenu[newSecurityGroup].map((item) => item.name) : [];
        this.activeTabCategoryCounts = this.groupCategoryCounts[this.activeSecurityGroupTab];
        this.listItems = [];
        if (this.categories.length) {
            this.selectCategory(this.categories[0]);
        }
    }
    removeItem(itemToRemove) {
        this.selectedItems = this.selectedItems.filter((selectItem) => selectItem.item.key !== itemToRemove.item.key || selectItem.group !== this.activeSecurityGroupTab);
        this.updateCategoryCounts(-1);
    }
    selectAutocompleteResult(result) {
        // If it's not already selected then add it to the list of selected items
        if (!isMultiSelectListItemSelected(result, this.selectedItems, this.activeSecurityGroupTab)) {
            this.selectedItems.push({ item: result, group: this.activeSecurityGroupTab });
            // Get new object reference to make pure pipes run again
            this.selectedItems = this.selectedItems.slice();
            this.updateCategoryCounts(1);
        }
    }
    selectListItem(multiSelectItem, deselectIfSelected = true) {
        if (!this.featureService.userCanAccess(multiSelectItem.item)) {
            const missing_feature = this.featureService.getFirstMissingFeature(multiSelectItem.item);
            this.featureNeededModal.openModal(missing_feature);
        }
        else if (isMultiSelectListItemSelected(multiSelectItem.item, this.selectedItems, this.activeSecurityGroupTab) &&
            deselectIfSelected) {
            // If the list item is already selected then deselect it by removing it
            // from the list of selected items
            this.removeItem(multiSelectItem);
        }
        else {
            this.selectedItems.push(multiSelectItem);
            // Get new object reference to make pure pipes run again
            this.selectedItems = this.selectedItems.slice();
            this.updateCategoryCounts(1);
        }
    }
    selectSubListItemByAutocomplete(autocompleteResult) {
        // find the sub list item with the id in the key that matches
        // the id of the autocomplete result that was selected
        for (let i = 0; i < this.listItems.length; i += 1) {
            const sublist = this.listItems[i].sub_list;
            if (sublist) {
                const subItemFound = sublist.find((subItem) => {
                    const typeAndId = subItem.key.split('-');
                    const subItemId = parseInt(typeAndId[typeAndId.length - 1], 10);
                    return subItemId === autocompleteResult.id;
                });
                if (subItemFound) {
                    this.selectListItem({
                        item: subItemFound,
                        group: this.activeSecurityGroupTab,
                    }, false);
                    return;
                }
            }
        }
    }
    updateCategoryCounts(countChange) {
        if (this.selectedCategory in this.activeTabCategoryCounts) {
            this.activeTabCategoryCounts[this.selectedCategory] += countChange;
        }
        else {
            this.activeTabCategoryCounts[this.selectedCategory] = countChange;
        }
    }
}
MultiSecurityListSelectorModalComponent.ɵfac = function MultiSecurityListSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiSecurityListSelectorModalComponent)(i0.ɵɵdirectiveInject(i1.SecurityListMenuService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
MultiSecurityListSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiSecurityListSelectorModalComponent, selectors: [["ycn-multi-security-list-selector-modal"]], viewQuery: function MultiSecurityListSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { activeSecurityGroupTab: "activeSecurityGroupTab", headerText: "headerText", securityGroupTabOptions: "securityGroupTabOptions", showSetOperations: "showSetOperations", selectedSetOperation: "selectedSetOperation" }, outputs: { submitHandler: "submitHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 8, consts: [["multiSelectList", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "resetModalHandler", "header", "resetModalText"], [1, "modal-body"], [1, "modal-section", "form-row"], [3, "groupName", "options", "selectedObject", "selectHandler", 4, "ngIf"], [1, "modal-section"], [3, "loaderMessage"], [3, "cancelHandler", "submitHandler", "disableSubmission", "errorText", "selectedItemCount"], [3, "selectHandler", "groupName", "options", "selectedObject"], ["class", "tabs tabs-bordered", 3, "activeSecurityGroupTab", "securityGroupTabOptions", "securityGroupChangeHandler", 4, "ngIf"], [1, "tab-content", "linked-list"], [3, "ngClass"], [1, "linked-lists", 3, "ngClass"], [1, "linked-list"], [1, "linked-list-header", "user-select-none"], [1, "linked-list-body", 3, "categoryChangeHandler", "categories", "categoryCounts", "selectedCategory"], ["class", "linked-list-body-content", 4, "ngIf"], ["class", "linked-list-body", 3, "autocompleterName", "autocompleterPlaceholder", "selectedItems", "removeItemHandler", "selectItemHandler", 4, "ngIf"], [1, "linked-list-body", "user-select-none"], [1, "linked-list-sublist", "file-table"], ["class", "tbody", 3, "listItems", "activeSecurityGroupTab", "selectedItems", "selectItemHandler", 4, "ngIf"], [1, "tabs", "tabs-bordered", 3, "securityGroupChangeHandler", "activeSecurityGroupTab", "securityGroupTabOptions"], [1, "linked-list-body-content"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "linked-list-body", 3, "removeItemHandler", "selectItemHandler", "autocompleterName", "autocompleterPlaceholder", "selectedItems"], [1, "tbody", 3, "selectItemHandler", "listItems", "activeSecurityGroupTab", "selectedItems"]], template: function MultiSecurityListSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function MultiSecurityListSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function MultiSecurityListSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function MultiSecurityListSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
        i0.ɵɵtemplate(4, MultiSecurityListSelectorModalComponent_ycn_radio_button_group_4_Template, 1, 3, "ycn-radio-button-group", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 6);
        i0.ɵɵconditionalCreate(6, MultiSecurityListSelectorModalComponent_Conditional_6_Template, 1, 1, "ycn-loading-symbol", 7)(7, MultiSecurityListSelectorModalComponent_Conditional_7_Template, 16, 13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "ycn-simple-modal-footer", 8);
        i0.ɵɵlistener("cancelHandler", function MultiSecurityListSelectorModalComponent_Template_ycn_simple_modal_footer_cancelHandler_8_listener() { return ctx.closeModal(); })("submitHandler", function MultiSecurityListSelectorModalComponent_Template_ycn_simple_modal_footer_submitHandler_8_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(9, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.headerText)("resetModalText", "Reset");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showSetOperations);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.loading ? 6 : 7);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disableSubmission", !ctx.selectedItems.length)("errorText", ctx.errorText)("selectedItemCount", ctx.selectedItems ? ctx.selectedItems.length : undefined);
    } }, dependencies: [i3.NgClass, i3.NgIf, i4.FeatureNeededComponent, i5.IconSearchAutocompleteComponent, i6.LoadingSymbolComponent, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.SimpleModalHeaderComponent, i10.RadioButtonGroupComponent, i11.AutocompleterMultiSelectListComponent, i12.CategoryListComponent, i13.MultiLevelMultiSelectListComponent, i14.SecurityListGroupTabsComponent], encapsulation: 2 });
